var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8163 4.91528L6.20185 4.91528C5.25761 4.91528 4.35205 5.29038 3.68437 5.95806C3.0167 6.62573 2.6416 7.5313 2.6416 8.47553V20.343C2.6416 21.2873 3.0167 22.1928 3.68437 22.8605C4.35205 23.5282 5.25761 23.9033 6.20185 23.9033H22.8163C23.7606 23.9033 24.6661 23.5282 25.3338 22.8605C26.0015 22.1928 26.3766 21.2873 26.3766 20.343V8.47553C26.3766 7.5313 26.0015 6.62573 25.3338 5.95806C24.6661 5.29038 23.7606 4.91528 22.8163 4.91528ZM22.8163 7.28878L15.1025 12.5936C14.9221 12.6977 14.7174 12.7525 14.5091 12.7525C14.3008 12.7525 14.0961 12.6977 13.9157 12.5936L6.20185 7.28878L22.8163 7.28878Z",
    fill: "#051B66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.4761f55b179f7f91b33fb7ce80c99b90.svg";
export { ForwardRef as ReactComponent };